import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import '@fontsource-variable/geist';
import './index.css';

import { AppProviders } from './AppProviders';
import { Analytics } from './components/analytics';
import { AppRoutes } from './routes';
import { installBugReportCollector } from './features/bug-report/collector';
import { UpdateNotice } from './features/app-update/UpdateNotice';

// Before the first render, so a report can include whatever broke during startup.
installBugReportCollector();

const root = document.getElementById('root')!;
const app = (
  <AppProviders>
    <BrowserRouter>
      <Analytics />
      <UpdateNotice />
      <AppRoutes />
    </BrowserRouter>
  </AppProviders>
);

// The public pages ship as prerendered HTML (scripts/prerender.mjs), so on
// those the root already holds the page and React attaches to it instead of
// replacing it. The app shell's index.html has an empty root and mounts fresh.
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
